import { KeycloakEventType, KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { environment } from '../../environments/environment';

// export function initializer(keycloak: KeycloakService): () => Promise<boolean> {

//   const options: KeycloakOptions = {
//     config : environment.keycloak,
//     loadUserProfileAtStartUp: true,
//     initOptions: {
//         onLoad: 'check-sso',
//         checkLoginIframe: false
//     },
//     bearerExcludedUrls: ['/api/public']
//   };

//   return () => keycloak.init(options);

// }

export function initializer(keycloak: KeycloakService) {
  const options: KeycloakOptions = {
    config: environment.keycloak,

    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoFallback: true,
      checkLoginIframe: true,
    },
    enableBearerInterceptor:true,
    bearerExcludedUrls: ['/api/public'],
  };
  return async () => {
    try {
      await keycloak.init(options);
    } catch (error) {
      // console.error(error);
    }
  };
}
